/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {

        var accessToken = '6093666.1654d0c.b2a5aa8c9b8f43b18d6daac63a6da3ca';

        // JavaScript to be fired on the home page, after the init JS
        var userFeed = new Instafeed({
            get: 'user',
            userId: '1767286386',
            accessToken: accessToken,
            clientId: '1767286386',
            limit: 7,
            resolution: 'standard_resolution',
            template: '<li class="col-xs-6 text-center no-pad" style="background-image:url({{image}})"><a href="{{image}}" data-lity></a></li>'
        });
        userFeed.run();

        var heroFeed = new Instafeed({
            get: 'user',
            target: 'hero_img',
            userId: '1767286386',
            accessToken: accessToken,
            clientId: '1767286386',
            limit: 1,
            resolution: 'standard_resolution',
            template: '<div class="img-wrapper" style="background-image:url({{image}})"><a href="{{image}}" data-lity></a></div>'
        });
        heroFeed.run();
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'find_a_store': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
      finalize: function() {
        //console.log('hello page locator!!!!');
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // var windowWidth = $(window).width();
  //   if(windowWidth > 768){
  //       $(offcanvas_selector)..offcanvas('hide');
  //   }

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
